import { type ReactNode, useEffect, useRef, useState } from "react";
import styles from "./QuestionSection.module.css";

interface QuestionSectionProps {
	title: string;
	subtitle: string;
	helpText: string;
	children: ReactNode;
}

export function QuestionSection({
	title,
	subtitle,
	helpText,
	children,
}: QuestionSectionProps) {
	const [popoverOpen, setPopoverOpen] = useState(false);
	const helpRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!popoverOpen) return;

		function handleClickOutside(e: MouseEvent) {
			if (helpRef.current && !helpRef.current.contains(e.target as Node)) {
				setPopoverOpen(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [popoverOpen]);

	return (
		<div className={styles.section}>
			<div className={styles.headingRow}>
				<h2 className={styles.heading}>{title}</h2>
				<div ref={helpRef} className={styles.helpWrapper}>
					<button
						type="button"
						className={styles.helpButton}
						aria-label="Help"
						aria-expanded={popoverOpen}
						onClick={() => setPopoverOpen((prev) => !prev)}
					>
						?
					</button>
					{popoverOpen && <div className={styles.popover}>{helpText}</div>}
				</div>
			</div>
			<p className={styles.subtitle}>{subtitle}</p>
			<div className={styles.content}>{children}</div>
		</div>
	);
}
